import mod from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/jackpots/index.vue?vue&type=script&lang=js
// module id = Kbc6
// module chunks = 0